import { render, staticRenderFns } from "./Listagem.vue?vue&type=template&id=e18350da&scoped=true"
import script from "./Listagem.vue?vue&type=script&lang=js"
export * from "./Listagem.vue?vue&type=script&lang=js"
import style0 from "./Listagem.vue?vue&type=style&index=0&id=e18350da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e18350da",
  null
  
)

export default component.exports